/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Select_Folder_LabelInputs */



/**
* | output |
* | --- |
* | "Select target backup folder" |
*
* @param {Options_Backup_Select_Folder_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_select_folder_label = /** @type {((inputs?: Options_Backup_Select_Folder_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Select_Folder_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner le dossier de sauvegarde cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ziel-Sicherungsordner auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona la cartella di backup di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите целевую папку для резервного копирования.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar la carpeta de respaldo de destino")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择目标备份文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バックアップ先のフォルダを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य बैकअप फ़ोल्डर का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione a pasta de backup de destino.")
	return /** @type {LocalizedString} */ ("Select target backup folder")
});